export function buildSsoState(tenantId: string, origin: string): string {
  const json = JSON.stringify({ t: tenantId, o: origin });
  const bytes = new TextEncoder().encode(json);
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
